import { render, staticRenderFns } from "./ArticleCategView.vue?vue&type=template&id=6038d322&scoped=true"
import script from "./ArticleCategView.vue?vue&type=script&lang=js"
export * from "./ArticleCategView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6038d322",
  null
  
)

export default component.exports